export const savedReportTranslation = {
  overlay_text: 7486,
  submit: 7779,
  cancel: 3273,
  create_folder_button: 7786,
  create_folder_link: 7787,
  create_report_input_placeholder: 7788,
  copy: 7842,
  search_placeholder: 7557,
  link_to_report: 7781,
  share_with: 7784,
  title: 7775,
  users: 3650,
  user_group: 7843,
  owner: 6439,
  folder: 7841,
  report_title: 7778,
  succes_message_report: 7818,
  succes_message_folder: 7819,
  validation_error: 7702,
  no_options_found: 7644,
  page_of: 8454,
  must_be_filled: 7551,
  link_copy_success: 7826,
  link_copy_fail: 7825,
  done: 7338,
  copy_to_clipboard: 6438,
  saved_reports_title: 7827,
  back: 7518,
  move_report: 8200,
  move_folder: 8204,
  remove_report: 8160,
  confirm_remove: 8161,
  success_remove_report: 8162,
  remove_folder: 8165,
  confirm_remove_folder: 8166,
  search_required_message: 8146,
  update_report_title: 8322,
  update_report_button: 8323,
  edit_report: 8329,
  shared_report: 8358,
  shared_report_group: 8357,
  update_report_are_you_sure: 8324,
  update_report_other_users: 8335,
  update_report_not_undone: 8336,
  success_report_updated: 8334,
  shared: 8359,
  edit_folder: 8367,
  folder_title: 8368,
  save_folder: 8369,
  shared_folder_group: 8370,
  shared_folder_user: 8371,
  folder_updated: 8372,
  update_owners: 8373,
  share_contents: 8374,
  copy_sharing: 8375,
  saved_company_reports_title: 8788,
  save_new_company_report: 8787,
  update_existing_company_report: 8821
};

export const form = {
  title: 'title',
  folder: 'folder',
  owner: 'owner',
  user_group: 'user_group',
  users: 'users',
  link_to_report: 'link_to_report',
  create_folder_input: 'create_folder_input'
};

export const formFolder = {
  title: 'title',
  folder: 'folder',
  owner: 'owner',
  user_group: 'user_group',
  users: 'users',
  link_to_report: 'link_to_report',
  create_folder_input: 'create_folder_input',
  updateOwner: 'updateOwnerForAllDescendants',
  updateSharing: 'updateShareInformationForAllDescendants'
};

export const endpoint = {
  saveReport: 'favourite/definition',
  saveFolder: 'favourite/definition/folder',
  updateFolder: (folderId) => `favourite/definition/folder/${folderId}`,
  removeReport: (reportId) => `favourite/definition/${reportId}`,
  moveReport: (reportId:number) => `favourite/definition/${reportId}/parent`,
  loadOwnerOptions: 'favourite/definition/draft/options/owner',
  loadUsersOptions: 'favourite/definition/draft/options/users',
  loadUserGroupsOptions: 'favourite/definition/draft/options/userGroups',
  loadFolderOptions: 'user/current/options/folders',
  loadSavedReports: 'user/current/options/savedFavourites',
  loadUsersMetadata: 'favourite/definition/draft/options/users/metadata',
  favouriteDefinition: 'favourite/definition/draft'
};

export enum ReportId {
  CompanyReport = 11
}
